import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import GpsFixedOutlinedIcon from '@material-ui/icons/GpsFixedOutlined';
import { connect } from 'react-redux';
import { numberFormat, findArrayObject, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import TripActionDialog from './TripActionDialog';
import EditActionIcon from '../../components/Icons/EditActionIcon';
import DeleteActionIcon from '../../components/Icons/DeleteActionIcon';
import {
  editPartyDeduction,
  getTripDetailsV3
} from "../../../store/actions/tripActionCreator";
import DeletePartyCharge from './DeletePartyCharge';
import DeletePartyDeduction from './DeletePartyDeduction';
import DeletePartyPayment from './DeletePartyPayment';
import DeletePartyAdvance from './DeletePartyAdvance';
import { ViewBillIcon } from '../../../components/icons';
import ReportsDialog from '../ReportsDialog/ReportsDialog';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DeletePartyPaymentInitiated from './DeletePartyPaymentInitiated';
const useStyles = makeStyles((theme) => ({
  info: {
    padding: '12px 24px',
    borderRadius: 8
  },
  normal: {
    paddingLeft: 0,
    paddingBottom: 5,
    paddingTop: 5
  },
  normalProfit: {
    paddingLeft: 0,
    borderTop: '2px dotted rgba(107, 119, 140, 0.51)'
  },
  nested: {
    paddingLeft: 16,
    paddingBottom: 5,
    paddingTop: 5,
    //paddingRight:24
  },
  nestedV1: {
    paddingLeft: 16,
    paddingBottom: 5,
    paddingTop: 5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'unset'
    //paddingRight:24
  },
  primaryNormal: {
    fontSize: 18,
    fontWeight: 600
  },
  primaryNormalParty: {
    fontSize: 18,
    fontWeight: 600,
    color: '#0033cc',
  },
  revenueNormalAmount: {
    color: '#0033cc',
    fontSize: 18
  },
  expenseNormalAmount: {
    color: 'red',
    fontSize: 18
  },
  profitNormalAmount: {
    color: '#008556',
    fontSize: 18
  },
  balanceNormalAmount: {
    color: '#0033cc',
    fontSize: 18,
    fontWeight: 600
  },
  primaryNested: {
    fontSize: 16
  },
  primaryFreighNested: {
    fontSize: 16,
    fontWeight: 300
  },
  nestedAmount: {
    fontSize: 18
  },
  nestedAmountV1: {
    fontSize: 18,
    paddingRight: 28
  },
  notPaid: {
    fontSize: 18,
    color: '#676B75'
  },
  nestedAmountFreight: {
    fontSize: 16,
    fontWeight: 300
  },
  viewBillButton: {
    borderRadius: 6,
    textTransform: 'capitalize',
    backgroundColor: '#0033cc',
    color: 'white',
    fontWeight: 'bold',
    letterSpacing: 1,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 4,
    paddingBottom: 4,
    fontSize: 13,
    '&:hover': {
      backgroundColor: '#0033cc'
    }
  },
  mlV1: {
    marginLeft: 6,
    marginTop: 1
  },
  viewIconV1: {
    color: 'white',
    fontSize: 22
  },
  divRelative: {
    position: 'relative'
  },
  lineThrough: {
    position: 'absolute', width: '100%', left: 0, borderTop: '2px solid red', top: '50%'
  },
  divV1: {
    display: 'flex', alignItems: 'center'
  },
  checkCircleIconV1: {
    color: '#008556', fontSize: 20, marginLeft: 8
  },
  divPaymentData: {
    color: 'grey', fontSize: 12, marginTop: 2
  },
  mlV1: {
    marginLeft: 5
  },
  pdV1: {
    paddingRight: 56
  },
  pdV2: {
    paddingRight: 27
  }
}));
const PartySummary = (props) => {
  const { location, tripDetails, dispatchTripDetailsAction, state } = props;
  const [open, setOpen] = React.useState(true);
  const [cashFlowItem, setCashFlowItem] = React.useState(null);
  const [cashFlowType, setCashFlowType] = React.useState(null);
  const [deletePartyChargeOpen, setDeletePartyChargeOpen] = useState(false);
  const [deletePartyDeductionOpen, setDeletePartyDeductionOpen] = useState(false);
  const [deletePartyPaymentOpen, setDeletePartyPaymentOpen] = useState(false);
  const [deletePartyAdvanceOpen, setDeletePartyAdvanceOpen] = useState(false);
  const [pdfOpen, setPdfOpen] = useState(false);
  const [deletePartyPaymentInitiated, setDeletePartyPaymentInitiated] = useState(false);
  const handleClick = () => {
    setOpen(!open);
  };
  const fetchTrip = (tripId) => {
    dispatchTripDetailsAction(tripId, () => {
    });
  }
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let tripId = tripDetails && tripDetails.id ? tripDetails.id : path[path.length - 1];
  let tripStatus = tripDetails && tripDetails.status ? tripDetails.status : '';
  let hiredTrip = tripDetails && tripDetails.vehicle && tripDetails.vehicle.ownershipType && tripDetails.vehicle.ownershipType == 'HIRED' ? true : false;
  const classes = useStyles();
  const [editCashFlowOpen, setEditCashFlowOpen] = useState(false);
  let editPartyCharge = {
    action: 'edit_party_charge',
    label: 'Update Charge',
    confirmText: 'Update Charge',
    tabsFormat: false
  }
  let editPartyReduction = {
    action: 'edit_party_reduction',
    label: 'Update Deduction',
    confirmText: 'Update Deduction',
    tabsFormat: false
  }
  let editPartyAdvance = {
    action: 'edit_party_advance',
    label: 'Update Advance',
    confirmText: 'Update Advance',
    tabsFormat: false
  }
  let editPartyPayment = {
    action: 'edit_party_payment',
    label: 'Update Payment',
    confirmText: 'Update Payment',
    tabsFormat: false
  }
  const handleEditCashFlow = (event, item, actionType) => {
    let cashflowItem;
    if (item && item.id && tripDetails && tripDetails.tripTransactions) {
      cashflowItem = findArrayObject('id', item.id, tripDetails.tripTransactions)
    }
    if (cashflowItem) {
      setCashFlowItem(cashflowItem);
      setCashFlowType(actionType);
      setEditCashFlowOpen(true);
    }
  }
  const handleEditCashflowActionClose = (status) => {
    setEditCashFlowOpen(status);
    setCashFlowItem(null);
    setCashFlowType(null);
    fetchTrip(tripId)
  }
  const handleOnUpdateSuccess = (status) => {
    setEditCashFlowOpen(status);
    setCashFlowItem(null);
    setCashFlowType(null);
    fetchTrip(tripId)
  }
  const resetCashFlow = () => {
    setCashFlowItem(null);
    setCashFlowType(null);
  }
  const onDeletePartyCharge = (event, item) => {
    setCashFlowItem(item);
    setDeletePartyChargeOpen(true);
  }
  const onPartyChargeDeleteSuccess = () => {
    fetchTrip(tripId)
    setDeletePartyChargeOpen(false);
    resetCashFlow()
  }
  const onPartyChargeDeleteCancel = () => {
    fetchTrip(tripId)
    setDeletePartyChargeOpen(false);
    resetCashFlow()
  }
  const onDeletePartyDdeduction = (event, item) => {
    setCashFlowItem(item);
    setDeletePartyDeductionOpen(true);
  }
  const onDeletePartyPayment = (event, item) => {
    setCashFlowItem(item);
    setDeletePartyPaymentOpen(true);
  }
  const onDeletePartyPaymentInitiated = (event, item) => {
    setCashFlowItem(item);
    setDeletePartyPaymentInitiated(true);
  }
  const onDeletePartyAdvance = (event, item) => {
    setCashFlowItem(item);
    setDeletePartyAdvanceOpen(true);
  }
  const onPartyDeductionDeleteSuccess = () => {
    fetchTrip(tripId)
    setDeletePartyDeductionOpen(false);
    resetCashFlow()
  }
  const onPartyPaymentDeleteSuccess = () => {
    fetchTrip(tripId)
    setDeletePartyPaymentOpen(false);
    resetCashFlow();
  }
  const onPartyAdvanceDeleteSuccess = () => {
    fetchTrip(tripId)
    setDeletePartyAdvanceOpen(false);
    resetCashFlow()
  }
  const onPartyDeductionDeleteCancel = () => {
    fetchTrip(tripId)
    setDeletePartyDeductionOpen(false);
    resetCashFlow()
  }
  const onPartyPaymentDeleteCancel = () => {
    fetchTrip(tripId)
    setDeletePartyPaymentOpen(false);
    resetCashFlow();
  }
  const onPartyAdvanceDeleteCancel = () => {
    fetchTrip(tripId)
    setDeletePartyAdvanceOpen(false);
    resetCashFlow()
  }
  const handleClose = () => {
    setPdfOpen(false);
  }
  const handleViewBill = () => {
    setPdfOpen(true);
  }
  const handlePaymentInitiatedClose = () => {
    fetchTrip(tripId);
    setDeletePartyPaymentInitiated(false);
    resetCashFlow();
  }

  const handlePaymentInitiatedConfirm = () => {
    fetchTrip(tripId);
    setDeletePartyPaymentInitiated(false);
    resetCashFlow();
  }

  return (
    <Paper className={classes.info}>
      <List
        component="nav"
        aria-labelledby="profit-summary-list"
        className={classes.root}
      >
        <ListItem className={classes.normal}>
          <ListItemText primary={tripDetails.partyName} classes={{ primary: classes.primaryNormalParty }} />
          {/* <span className={classes.revenueNormalAmount}>{numberFormat(Number(tripDetails.profitSummaryRevenueAmount))}</span> */}
          <div>
            <Button variant="contained" className={classes.viewBillButton} onClick={() => handleViewBill()}>
              <ViewBillIcon className={classes.viewIconV1} /> <span className={classes.mlV1}>View Bill</span>
            </Button>
          </div>
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem className={classes.nested}>
              <ListItemText primary='Freight Amount' classes={{ primary: classes.primaryFreighNested }} />
              <span className={classes.nestedAmountFreight}>{numberFormat(tripDetails && tripDetails.partyFreightAmount ? tripDetails.partyFreightAmount : 0)}</span>
            </ListItem>
            {
              tripDetails && tripDetails.partyAdvances && tripDetails.partyAdvances.map((item, index) => {
                return (<ListItem className={classes.nested}>
                  <ListItemText primary={<span>{item.displayName} </span>} classes={{ primary: classes.primaryNested }} />
                  <span className={classes.nestedAmount}>{numberFormat(item.amount)}{tripStatus != 'PAYMENT_RECEIVED' && item.id && <><EditActionIcon onClick={(e) => { handleEditCashFlow(e, item, editPartyAdvance) }} /><DeleteActionIcon onClick={(e) => { onDeletePartyAdvance(e, item) }} /></>}</span>
                </ListItem>)
              })
            }
            {
              tripDetails && tripDetails.partyCharges && tripDetails.partyCharges.map((item, index) => {
                return (<ListItem className={classes.nested}>
                  <ListItemText primary={<span>{item.displayName} </span>} classes={{ primary: classes.primaryNested }} />
                  <span className={classes.nestedAmount}>{numberFormat(item.amount)}{tripStatus != 'PAYMENT_RECEIVED' && item.id && <><EditActionIcon onClick={(e) => { handleEditCashFlow(e, item, editPartyCharge) }} /><DeleteActionIcon onClick={(e) => { onDeletePartyCharge(e, item) }} /></>}</span>
                </ListItem>)
              })
            }
            {
              tripDetails && tripDetails.partyDeductions && tripDetails.partyDeductions.map((item, index) => {
                return (<ListItem className={classes.nested}>
                  <ListItemText primary={<span>{item.displayName} </span>} classes={{ primary: classes.primaryNested }} />
                  <span className={classes.nestedAmount}>{numberFormat(item.amount)}{tripStatus != 'PAYMENT_RECEIVED' && item.id && <><EditActionIcon onClick={(e) => { handleEditCashFlow(e, item, editPartyReduction) }} /><DeleteActionIcon onClick={(e) => { onDeletePartyDdeduction(e, item) }} /></>}</span>
                </ListItem>)
              })
            }
            {
              tripDetails && tripDetails.partyPayments && tripDetails.partyPayments.map((item, index) => {
                return (
                  <>
                    <div className={item.paymentLinkStatus == "CANCELLED" || item.paymentLinkStatus == "EXPIRED" ? classes.divRelative : ""}>
                      <ListItem className={classes.nestedV1} >
                        <div className={classes.divV1}>
                          <ListItemText primary={<span>{item.displayName} </span>} classes={{ primary: classes.primaryNested }} />
                          <span className={(tripDetails.partyAdvances.length > 0 || tripDetails.partyCharges.length > 0 || tripDetails.partyDeductions.length > 0) && tripDetails.partyPayments.some((data) => (data.hasOwnProperty('isBrokerEnabled'))) ? tripDetails.partyPayments.some((data) => (data.isBrokerEnabled == false)) ? item.isBrokerEnabled ? classes.nestedAmountV1 : classes.nestedAmount : (tripDetails.partyAdvances.length > 0 || tripDetails.partyCharges.length > 0 || tripDetails.partyDeductions.length > 0) ? classes.nestedAmountV1 : classes.nestedAmount : tripDetails.partyPayments.some((data) => (data.hasOwnProperty('isBrokerEnabled') && data.isBrokerEnabled == false)) ? item.isBrokerEnabled ? classes.nestedAmountV1 : classes.nestedAmount : classes.nestedAmount}>
                            <span className={tripStatus != 'PAYMENT_RECEIVED' ? (tripDetails.partyAdvances.length > 0 || tripDetails.partyCharges.length > 0 || tripDetails.partyDeductions.length > 0) && !tripDetails.partyPayments.some((value) => value.hasOwnProperty('isBrokerEnabled')) ? classes.pdV1 : tripDetails.partyPayments.some((value) => value.hasOwnProperty('isBrokerEnabled')) ? tripDetails.partyPayments.some((data) => (data.isBrokerEnabled == false)) ? item.hasOwnProperty('isBrokerEnabled') ? "" : classes.pdV1 : item.hasOwnProperty('isBrokerEnabled') ? "" : classes.pdV2 : "" : ""}>
                              <span className={item.hasOwnProperty('isBrokerEnabled') ? "" : classes.notPaid}>
                                {numberFormat(item.amount)}
                              </span>
                            </span>
                            {/* tripDetails.partyPayments.some((data) => (data.hasOwnProperty('isBrokerEnabled'))) && item.isBrokerEnabled ? classes.nestedAmountV1 : classes.nestedAmount */}
                            {tripStatus != 'PAYMENT_RECEIVED' && item.id && item.hasOwnProperty('isBrokerEnabled') && !item.isBrokerEnabled &&
                              <>
                                <EditActionIcon onClick={(e) => { handleEditCashFlow(e, item, editPartyPayment) }} />
                                <DeleteActionIcon onClick={(e) => { onDeletePartyPayment(e, item) }} />
                              </>
                            }

                            {tripStatus != 'PAYMENT_RECEIVED' && item.paymentLinkStatus == "ACTIVE" && <>
                              {/* <EditActionIcon onClick={(e) => { handleEditCashFlow(e, item, editPartyPayment) }} /> */}
                              <span className={classes.mlV1}>
                                <DeleteActionIcon onClick={(e) => { onDeletePartyPaymentInitiated(e, item) }} />
                              </span>
                            </>}

                            {item.id && item.isBrokerEnabled &&
                              <CheckCircleIcon className={classes.checkCircleIconV1} />
                            }

                          </span>
                        </div>
                        {item.paymentData &&
                          <div className={classes.divPaymentData}>
                            {item.paymentData}
                          </div>
                        }
                      </ListItem>
                      {item.paymentLinkStatus == "CANCELLED" &&
                        <span className={classes.lineThrough}></span>
                      }
                      {
                        item.paymentLinkStatus == "EXPIRED" &&
                        <span className={classes.lineThrough}></span>
                      }
                    </div>
                  </>
                )
              })
            }
          </List>
        </Collapse>
        <ListItem className={classes.normalProfit}>
          <ListItemText primary="Party Balance" classes={{ primary: classes.primaryNormal }} />
          <span className={classes.balanceNormalAmount}>{numberFormat(Number(tripDetails && tripDetails.partyBalance ? tripDetails.partyBalance : 0))}</span>
        </ListItem>
      </List>
      {editCashFlowOpen && <TripActionDialog action={cashFlowType} editData={cashFlowItem} open={editCashFlowOpen} onClose={handleEditCashflowActionClose} onUpdateSuccess={handleOnUpdateSuccess} confirmText={cashFlowType.confirmText ? cashFlowType.confirmText : null} />}
      {deletePartyChargeOpen && <DeletePartyCharge deleteOpen={deletePartyChargeOpen} tripId={tripId} deleteId={cashFlowItem.id} onDeleteSucees={onPartyChargeDeleteSuccess} onDeleteNo={onPartyChargeDeleteCancel} />}
      {deletePartyDeductionOpen && <DeletePartyDeduction deleteOpen={deletePartyDeductionOpen} tripId={tripId} deleteId={cashFlowItem.id} onDeleteSucees={onPartyDeductionDeleteSuccess} onDeleteNo={onPartyDeductionDeleteCancel} />}
      {deletePartyPaymentOpen && <DeletePartyPayment deleteOpen={deletePartyPaymentOpen} tripId={tripId} deleteId={cashFlowItem.id} onDeleteSucees={onPartyPaymentDeleteSuccess} onDeleteNo={onPartyPaymentDeleteCancel} />}
      {deletePartyAdvanceOpen && <DeletePartyAdvance deleteOpen={deletePartyAdvanceOpen} tripId={tripId} deleteId={cashFlowItem.id} onDeleteSucees={onPartyAdvanceDeleteSuccess} onDeleteNo={onPartyAdvanceDeleteCancel} />}
      {pdfOpen &&
        <ReportsDialog open={pdfOpen} name={"Trip Bill"} tripIdFromPartySummary={tripId} onClose={handleClose} />
      }
      {deletePartyPaymentInitiated && <DeletePartyPaymentInitiated paymentData={numberFormat(cashFlowItem.amount)} open={deletePartyPaymentInitiated} deleteId={cashFlowItem.customerPaymentId} onClose={handlePaymentInitiatedClose} onDeleteConfirm={handlePaymentInitiatedConfirm} />}
    </Paper>
  );
}
const PartySummaryWithRouter = withRouter(PartySummary);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchTripDetailsAction: (tripId, onSuccess, onError) =>
    dispatch(getTripDetailsV3(tripId, onSuccess, onError)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartySummaryWithRouter);